import { useRecoilState, useResetRecoilState } from "recoil"
import { StyledButton } from "../../components/common/Buttons"
import quizPreinfoState from "../../recoil/quizPreinfo"

interface PreinfoOptionsType {
  [key: string]: string[]
}

const usePreinfoButtons = (theme: string) => {
  const options: PreinfoOptionsType = {
    대분류: ["문과", "이과", "예체능", "잘 모르겠습니다"],
    문과: ["인문", "사회", "교육(문과)", "잘 모르겠습니다"],
    이과: ["자연", "교육(이과)", "의약학", "농학", "잘 모르겠습니다"],
    예체능: ["예체능", "교육(예체능)", "잘 모르겠습니다"],
  }

  const [preinfo, setPreinfo] = useRecoilState(quizPreinfoState)
  const resetPreinfo = useResetRecoilState(quizPreinfoState)

  const selectMajor = (option: string) => {
    if (option === preinfo.major) {
      resetPreinfo()
      localStorage.setItem(
        "quizPreinfo",
        JSON.stringify({ major: "", detailedMajor: "" })
      )
    } else {
      setPreinfo({ major: option, detailedMajor: "" })
      localStorage.setItem(
        "quizPreinfo",
        JSON.stringify({ major: option, detailedMajor: "" })
      )
    }
  }

  const selectDetailedMajor = (option: string) => {
    if (option === preinfo.detailedMajor) {
      setPreinfo({ ...preinfo, detailedMajor: "" })
      localStorage.setItem(
        "quizPreinfo",
        JSON.stringify({ ...preinfo, detailedMajor: "" })
      )
    } else {
      setPreinfo({ ...preinfo, detailedMajor: option })
      localStorage.setItem(
        "quizPreinfo",
        JSON.stringify({ ...preinfo, detailedMajor: option })
      )
    }
  }

  let buttons: JSX.Element[] = []
  if (theme === "" || theme === "잘 모르겠습니다") {
    return buttons
  }

  options[theme].forEach((option) => {
    const newButton = (
      <StyledButton
        key={option}
        $bgColor={
          (theme === "대분류" ? preinfo.major : preinfo.detailedMajor) ===
          option
            ? "var(--custom-blue)"
            : ""
        }
        $textColor={
          (theme === "대분류" ? preinfo.major : preinfo.detailedMajor) ===
          option
            ? "var(--custom-beige)"
            : ""
        }
        onClick={() =>
          theme === "대분류" ? selectMajor(option) : selectDetailedMajor(option)
        }
      >
        {option}
      </StyledButton>
    )
    buttons.push(newButton)
  })

  return buttons
}

export default usePreinfoButtons
